import React from 'react';
import { ReactSortable } from 'react-sortablejs';
import type { PromoUploadStatusType } from '@entities/adCampaign';
import IconGrip from '@zvuk-b2b/react-uikit/ui/icons/GripVertical';
import VideoPromoItem from '../VideoPromoItem';
import { getVideoPromoDurationRaw } from '../videoPromoDraft';
import type { VideoPromoListProps } from './types';
import { getReorderedVideoPromos } from './utils';
import styles from './index.module.scss';

const VideoPromoList: React.FC<VideoPromoListProps> = ({
  items,
  isExactTime,
  isSortable = true,
  isDisabled,
  timeById,
  durationById,
  onTimeChange,
  onDurationChange,
  onRemove,
  onRetry,
  onReorder,
}) => {
  const canSort = isSortable && items.length > 1;
  return (
    <ReactSortable<PromoUploadStatusType & { id: string }>
      tag="ul"
      className={styles.list}
      list={items
        .filter((item): item is PromoUploadStatusType & { id: string } => !!item.id)
        .map((item) => ({ ...item }))}
      setList={(next) => {
        if (isDisabled || !canSort) return;
        const reordered = getReorderedVideoPromos(items, next);
        if (reordered) onReorder(reordered);
      }}
      handle={`.${styles.drag}`}
      disabled={isDisabled || !canSort}>
      {items.map(
        (item) =>
          item.id && (
            <li
              key={item.id}
              className={styles.item}>
              <VideoPromoItem
                item={item}
                isExactTime={isExactTime}
                isDisabled={isDisabled}
                leading={
                  canSort ? (
                    <span
                      className={styles.drag}
                      data-testid={`video_promo_drag_${item.id}`}>
                      <IconGrip />
                    </span>
                  ) : undefined
                }
                duration={getVideoPromoDurationRaw(item, durationById)}
                time={timeById[item.id] ?? ''}
                onDurationChange={(value) => onDurationChange(item.id!, value)}
                onTimeChange={(value) => onTimeChange(item.id!, value)}
                onRemove={() => onRemove(item.id!)}
                onRetry={() => onRetry(item.id!)}
              />
            </li>
          )
      )}
    </ReactSortable>
  );
};

export default VideoPromoList;
